import { render, staticRenderFns } from "./UdfFormBuilder.vue?vue&type=template&id=2db26d2f"
import script from "./UdfFormBuilder.vue?vue&type=script&lang=js"
export * from "./UdfFormBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports